import React, { Component } from 'react'
import { Columns } from '../../elements'
import { CLOUDINARY_NAME, CLOUDINARY_API_KEY } from '../../../constants/images/cloudinary'
import { userPhotoURL } from '../../../constants/images/sizesAndQuality'
import cloudinary from 'cloudinary-core'
const cl = new cloudinary.Cloudinary({
    cloud_name: CLOUDINARY_NAME,
    api_key: CLOUDINARY_API_KEY,
})

class AuthorBlock extends Component {

    render () {
        const { authorData } = this.props
      return (
        <React.Fragment>
          <div className="author-block-wrap">
            <Columns breakpoint="mobile">
              <Columns.Column mobile={{ size: 3 }} tablet={{ size: 3 }}>
                <img
                  src={cl.url(
                    userPhotoURL(
                      authorData.profile_image === ""
                        ? null
                        : authorData.profile_image
                    ),
                    {
                      gravity: "center",
                      height: 150,
                      width: 150,
                      crop: "fill",
                      format: "jpg",
                      type: "fetch"
                    }
                  )}
                  className="is-rounded"
                  alt={authorData.first_name + " " + authorData.last_name}
                />
              </Columns.Column>
              <Columns.Column mobile={{ size: 9 }} tablet={{ size: 9 }}>
                <strong>
                  {authorData.first_name} {authorData.last_name}
                </strong>
                <p>{authorData.bio}</p>
                <div className='author-social-icons'>
                  {authorData.linkedin_url && (
                    <a href={authorData.linkedin_url} target='_blank'><img src="/static/images/socialMediaIcons/linkedIn.png" alt="linkedin url" /></a>
                  )}
                  {authorData.facebook_url && (
                    <a href={authorData.facebook_url} target='_blank'><img src="/static/images/socialMediaIcons/facebook.png" alt="facebook url" /></a>
                  )}
                  {authorData.instagram_url && (
                    <a href={authorData.instagram_url} target='_blank'><img src="/static/images/socialMediaIcons/instagram.png" alt="instagram url" /></a>
                  )}
                  {authorData.pinterest_url && (
                    <a href={authorData.pinterest_url} target='_blank'><img src="/static/images/socialMediaIcons/pinterest.png" alt="pinterest url" /></a>
                  )}
                  {authorData.twitter_handle && (
                    <a href={authorData.twitter_handle} target='_blank'><img src="/static/images/socialMediaIcons/twitter.png" alt="twitter url" /></a>
                  )}
                </div>
              </Columns.Column>
            </Columns>
          </div>
        </React.Fragment>
      )
    }
  }

export default AuthorBlock
